import loadRoamingSignature from '../utils/loadRoamingSignature';
import { lazyLoadSignatureInUserOptions } from 'owa-options-message-options';
import { isFeatureEnabled } from 'owa-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getStore } from '../store/signatureStore';

export default async function loadSignature() {
    if (isFeatureEnabled('cmp-roaming-signature')) {
        const store = getStore();
        if (store.legacySignature.html === null || store.legacySignature.txt === null) {
            return loadRoamingSignature();
        }
    } else {
        const userOptions = getUserConfiguration().UserOptions;
        if (userOptions.SignatureHtml === null || userOptions.SignatureText === null) {
            return lazyLoadSignatureInUserOptions.importAndExecute();
        }
    }

    return Promise.resolve();
}
